var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"dateTimeStr"},[_vm._v(_vm._s(_vm.utc0DateStr))])
}
var staticRenderFns = []

export { render, staticRenderFns }